import type { EmailDocument } from "../domain/types";

export type TEmailDocumentValidationSuccess = {
  ok: true;
  errors: string[];
  document: EmailDocument;
};

export type TEmailDocumentValidationFailure = {
  ok: false;
  errors: string[];
  document: null;
};

export type TEmailDocumentValidationResult =
  | TEmailDocumentValidationSuccess
  | TEmailDocumentValidationFailure;

export function emailDocumentValidationSuccess(
  document: EmailDocument,
): TEmailDocumentValidationSuccess {
  return {
    ok: true,
    errors: [],
    document,
  };
}

export function emailDocumentValidationFailure(
  errors: string[],
): TEmailDocumentValidationFailure {
  return {
    ok: false,
    errors: [...errors],
    document: null,
  };
}
